import { getUsersList } from '@/api/requests/users';
export const createMentionUserFn = (queryParams) => {
    return async (q) => {
        const { results } = await getUsersList({ ...queryParams, limit: 50, q });
        return results;
    };
};
